import React from "react";
import { useTranslation } from "react-i18next";

import { legendItemStyle, legendStyle } from "./style";

const FlashFlood3hEULegend = () => {
  const { t } = useTranslation();

  return (
    <div style={legendStyle}>
      <div>
        <b>{t("riskAssessment.flashflood")} (ITA) - 3h</b>
      </div>
      <div>
        <span style={legendItemStyle("#f9f9f9")}></span>Low: 0 &lt; pp level (mm/h) &lt; 6
      </div>
      <div>
        <span style={legendItemStyle("#d0efff")}></span>
        Moderate: 6 &le; pp level (mm/h) &lt; 10
      </div>
      <div>
        <span style={legendItemStyle("#187bcd")}></span>
        Significant: 10 &le; pp level (mm/h) &lt; 14
      </div>
      <div>
        <span style={legendItemStyle("#03254c")}></span>
        High: pp level (mm/h) &ge; 14
      </div>

      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "x-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          pp level = precipitation level, measured in mm/h
        </span>
      </div>
      <div>
        <span
          style={{
            marginTop: 10,
            fontSize: "xx-small",
            display: "block",
            float: "left",
            width: "200px",
            lineHeight: 1,
          }}
        >
          © CyStellar, Data from RAIN Project, funded by the European Commission, processed by CyStellar
        </span>
      </div>
    </div>
  );
};

export default FlashFlood3hEULegend;
